import BrandOverview from './BrandOverview.Container';

export default BrandOverview;
